import React, { useEffect, useState, useCallback } from "react";

import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import { FaDownload } from "react-icons/fa";

import {
  Flex,
  Button,
  useDisclosure,
  Link,
  Icon,
  SimpleGrid,
  Box,
} from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";

import CadastrarPessoaModal from "./Cadastrar";
import Group from "./Group";
import Table from "./Table";

import { API } from "../../../../main/config";
import PessoaEmCumprimentoSAService from "../../../../main/services/PessoaEmCumprimentoSAService";
import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";

import {
  criancaFunc,
  Permission,
  servicos,
} from "../../../../helpers/Funcionalidades";
import SemRegistros from "../../../components/SemRegistros";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { useAuthProvider } from "../../../../Context/AuthProvider";

const PessoaEmCumprimentoServicoAcolhimento = () => {
  const { id } = useParams();
  const history = useHistory();

  const { roleKeycloack, user } = useAuthProvider();
  const {
    setCadastrarPenaServ,
    setEditarPenaServ,
    cadastrarPenaServ,
    editarPenaServ,
  } = useAppContext();
  const {
    isOpen: isOpenCadastro,
    onOpen: onOpenCadastro,
    onClose: onCloseCadastro,
  } = useDisclosure();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const [dataSA, setDataSA] = useState();

  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Atividades Desenvolvidas",
      accessor: "atividadesDesenvolvidas",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Ofício e/ou Decisão Judicial",
      accessor: "anexoOficio",
      Cell: (props) => {
        return (
          <Flex justifyContent="center" pr={20}>
            {props.value && (
              <Link
                href={
                  props.value.pathAnexo.toString().includes(".png") ||
                  props.value.pathAnexo.toString().includes(".jpg") ||
                  props.value.pathAnexo.toString().includes(".jpeg") ||
                  props.value.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props.value.id}/visualizar`
                    : API + `/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            )}
          </Flex>
        );
      },
    },
  ];

  const handleGetPessoaEmCumprimento = useCallback(() => {
    setLoading(true);
    PessoaEmCumprimentoSAService.getPessoasEmCumprimentosSA(id)
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((erro) => {
        setLoading(false);
        setData([]);
      });
  }, [id, setLoading, setData]);

  useEffect(() => {
    handleGetPessoaEmCumprimento();

    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setDataSA(res.data);
        if (res.data.tipoServicoAcolhimento.regime === "SAF") {
          Swal.fire({
            title: "Atenção!",
            text: "Este Serviço de Acolhimento não pode acessar essa informação!",
            icon: "warning",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          }).then(() => {
            history.push(`/servico-acolhimento/${id}`);
          });
        }
      })
      .catch((error) => console.log(error));
  }, [history, id, handleGetPessoaEmCumprimento]);

  const handleCloseCadastroModal = () => {
    handleGetPessoaEmCumprimento();
    onCloseCadastro();
  };

  return roleKeycloack &&
    (roleKeycloack.includes(servicos.cumprimentoVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(dataSA?.idPessoaJuridica))) ? (
    !loading ? (
      <>
        <Flex
          flexDir="column"
          bgColor="#FFF"
          mt="25px"
          borderRadius="16px"
          py="15px"
          px="25px"
          position={"relative"}
        >
          <Permission
            roleKeycloack={roleKeycloack}
            func={servicos.cumprimentoCadastrar}
            id={dataSA?.idPessoaJuridica}
            user={user}
          >
            <Button
              id="button-cadastrar"
              color="#FFF"
              backgroundColor="#169499"
              fontWeight={700}
              position={"absolute"}
              fontSize="15px"
              lineHeight="21.6px"
              right={4}
              w={{ base: "30%", lg: "17%" }}
              _hover={{ bg: "#169499" }}
              onClick={onOpenCadastro}
            >
              Cadastrar
            </Button>
          </Permission>

          <Group title="Pessoa em Cumprimento de Pena">
            {data?.length > 0 ? (
              <Box mt={4}>
                <Table
                  data={data}
                  columns={columns}
                  handleGetPessoaEmCumprimento={handleGetPessoaEmCumprimento}
                  idSA={id}
                  roleKeycloack={roleKeycloack}
                  user={user}
                  editarPenaServ={editarPenaServ}
                  setEditarPenaServ={setEditarPenaServ}
                />
              </Box>
            ) : (
              <Box mt={2}>
                <SemRegistros buttonVisible={true} half />
              </Box>
            )}
          </Group>
        </Flex>

        {isOpenCadastro && (
          <CadastrarPessoaModal
            isOpen={isOpenCadastro}
            onOpen={onOpenCadastro}
            onClose={handleCloseCadastroModal}
            cadastrarPenaServ={cadastrarPenaServ}
            setCadastrarPenaServ={setCadastrarPenaServ}
          />
        )}
        <SimpleGrid
          mt="30px"
          columns={{ base: 1, sm: 2, lg: 5 }}
          spacing="20px"
          dir="rtl"
        ></SimpleGrid>
      </>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default PessoaEmCumprimentoServicoAcolhimento;
